import { Button } from '@econsult/econsult-ui/dist/components/Button';
import { Card, List, ListItem, Stack } from '@mui/material';
import { FlexColumnDiv } from 'components/Div/styles';
import { ModalCloseButton, ModalCloseIcon, MuiModal } from 'components/TemplateManager/ModalStyles';
import _map from 'lodash/map';
import React from 'react';
import { Product } from 'store/reducer/wallet';
import styled from 'styled-components';
import { ParagraphSmallHeavy, ParagraphXsmallRegular } from 'styles/elements/typography';

const StyledCard = styled(Card)`
  margin-top: 16px;
  color: ${({ theme }) => theme.colorPrimaryPrimary100} !important;
  background:
    linear-gradient(#FAFAFA, #FAFAFA) padding-box,
    linear-gradient(var(--angle, 0deg), #729DFF 4.23%, #78CCD5 38.35%, #FFAAD6 67.64%, #FFB64A 97.21%) border-box;
  animation: rotate 8s linear infinite;
  transition:
    background 0.3s ease,
    color 0.3s ease;
`;

const TopUpModalContainer = styled(FlexColumnDiv)`
  margin: 0;
  padding: 32px;
  background-color: #FAFAFA;
  outline: none;
  border: none;
  border-radius: 6px;
`;

interface TopUpModalProps {
  isOpen: boolean;
  onClose: () => void;
  products: Product[] | null;
  onBuy: (productId: string) => void;
}

interface CardData {
  id: string;
  title: string;
  price: string;
  bulletPoints: string[];
  buttonText: string;
  onClick: () => void;
  buttonSx?: object;
}

const TopUpModal: React.FC<TopUpModalProps> = ({ isOpen, onClose, products, onBuy }) => {
  const cardsData: CardData[] = _map(products || [], (product: Product) => ({
    id: product.id,
    title: product.title,
    price: `£${(product.unitAmountPence / 100).toFixed(2)}`,
    bulletPoints: product.bulletPoints,
    buttonText: product.buttonText,
    onClick: () => onBuy(product.id),
  }));
  const CardComponent: React.FC<{ data: CardData }> = ({ data }) => (
    <StyledCard variant="outlined" data-automation={`TopUpCard-${data.id}`}>
      <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ padding: '8px', margin: 0 }}>
        <Stack>
          <ParagraphSmallHeavy data-automation={`TopUpCardTitle-${data.id}`}>
            {data.title} ({data.price})
          </ParagraphSmallHeavy>
          <List dense sx={{ listStyleType: 'disc' }}>
            {data?.bulletPoints?.map(point => (
              <ListItem key={point} sx={{ ml: 3, display: 'list-item', p: 0 }}>
                <ParagraphXsmallRegular>{point}</ParagraphXsmallRegular>
              </ListItem>
            ))}
          </List>
        </Stack>
        <Button
          size="small"
          state="primary"
          onClick={data.onClick}
          disabled={false}
          data-automation={`BuyNowButton-${data.id}`}
          style={{ marginLeft: '28px' }}
        >
          {data.buttonText}
        </Button>
      </Stack>
    </StyledCard>
  );

  return (
    <MuiModal
      open={isOpen}
      onClose={onClose}
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
      }}
    >
      <TopUpModalContainer data-automation="ModalContainerPayment">
        <Stack direction="row" justifyContent="space-between" alignItems="center">
          <ParagraphSmallHeavy style={{ color: '#1E194B' }}>Top up here!</ParagraphSmallHeavy>
          <ModalCloseButton data-automation="ModalCloseButton-TopUpModal" type="button" tabIndex={0} onClick={onClose}>
            <ModalCloseIcon />
          </ModalCloseButton>
        </Stack>
        {cardsData.map(card => (
          <CardComponent key={card.id} data={card} />
        ))}
      </TopUpModalContainer>
    </MuiModal>
  );
};

export default TopUpModal;
